<ng-container *transloco="let t; read: 'submit-form-button'">
  {{ t('label') }}
</ng-container>
